<template>
  <buy-now-button v-if="showBuyNow"
                  :for-mobile="forMobile"
                  :disabled="disabled || buyNowDisabled"
                  @confirm="place_bid"/>
</template>

<script>
import {mapState} from "vuex";
import BuyNowButton from "../../lot-view/sidebar/BuyNowButton";
import lotBiddingMixin from "../../../mixins/lotBiddingMixin";

export default {
  name: "BiddingBuyNowButton",
  components: {BuyNowButton},
  mixins: [lotBiddingMixin],
  props: {
    disabled: {
      type: Boolean,
      default: () => false
    },
    forMobile: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    ...mapState(['mainConfig']),
  }
}
</script>

<style scoped>

</style>
